import type { Tag } from './tags.model';

export function generateTagObjects(): readonly Tag[] {
  return tags;
}

const tags = [
  angularTag(),
  excelTag(),
  htmlTag(),
  copywritingTag(),
  mobileAppTag(),
  financeIndustryTag(),
  ecommerceIndustryTag(),
  illustratorSoftwareTag(),
  excelSoftwareTag(),
] as const;

export function angularTag(): Tag {
  return {
    id: 101,
    name: 'angular',
    seoName: 'angular',
    isCategory: false,
    displayName: 'Angular',
  };
}

export function excelTag(): Tag {
  return {
    id: 102,
    name: 'excel',
    seoName: 'excel',
    isCategory: false,
    displayName: 'Excel',
  };
}

export function htmlTag(): Tag {
  return {
    id: 103,
    name: 'html',
    seoName: 'html',
    isCategory: false,
    displayName: 'HTML',
  };
}

export function copywritingTag(): Tag {
  return {
    id: 104,
    name: 'copywriting',
    seoName: 'copywriting',
    isCategory: false,
    displayName: 'Copywriting',
  };
}

export function mobileAppTag(): Tag {
  return {
    id: 105,
    name: 'mobileapp',
    seoName: 'mobileapp',
    isCategory: false,
    displayName: 'Mobile App Development',
  };
}

export function financeIndustryTag(): Tag {
  return {
    id: 106,
    name: 'finance',
    seoName: 'finance',
    isCategory: false,
    displayName: 'finance',
    families: [
      {
        id: 1,
        name: 'type of industry',
        question: 'What industry was the work for?',
      },
    ],
  };
}

export function ecommerceIndustryTag(): Tag {
  return {
    id: 107,
    name: 'ecommerce',
    seoName: 'ecommerce',
    isCategory: false,
    displayName: 'Ecommerce',
    families: [
      {
        id: 1,
        name: 'type of industry',
        question: 'What industry was the work for?',
      },
    ],
  };
}

export function illustratorSoftwareTag(): Tag {
  return {
    id: 108,
    name: 'illustrator',
    seoName: 'illustrator',
    isCategory: false,
    displayName: 'Adobe Illustrator',
    families: [
      {
        id: 2,
        name: 'tools and software',
        question: 'What tools and software did you use?',
      },
    ],
  };
}

export function excelSoftwareTag(): Tag {
  return {
    id: 109,
    name: 'excel',
    seoName: 'excel',
    isCategory: false,
    displayName: 'Microsoft Excel',
    families: [
      {
        id: 2,
        name: 'tools and software',
        question: 'What tools and software did you use?',
      },
    ],
  };
}
